import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M9.308 10.864A4.477 4.477 0 017 11.5a4.485 4.485 0 01-3.182-1.318A4.485 4.485 0 012.5 7c0-1.243.503-2.367 1.318-3.182A4.485 4.485 0 017 2.5c1.243 0 2.367.503 3.182 1.318A4.485 4.485 0 0111.5 7a4.48 4.48 0 01-.614 2.271c-.345.588-.29 1.326.193 1.808l2.568 2.568M7 9V5M5 7h4"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M13.962 16.296a6.716 6.716 0 01-3.462.954 6.728 6.728 0 01-4.773-1.977A6.728 6.728 0 013.75 10.5c0-1.864.755-3.551 1.977-4.773A6.728 6.728 0 0110.5 3.75c1.864 0 3.551.755 4.773 1.977A6.728 6.728 0 0117.25 10.5a6.726 6.726 0 01-.921 3.407c-.517.882-.434 1.988.289 2.711l3.853 3.853M10.5 13.5v-6m-3 3h6"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M27.924 32.592A13.432 13.432 0 0121 34.5c-3.728 0-7.102-1.51-9.546-3.954A13.455 13.455 0 017.5 21c0-3.728 1.51-7.102 3.954-9.546A13.455 13.455 0 0121 7.5c3.728 0 7.102 1.51 9.546 3.954A13.455 13.455 0 0134.5 21c0 2.486-.672 4.814-1.842 6.814-1.034 1.764-.868 3.976.578 5.422l7.706 7.706M21 27V15m-6 6h12"
  }))
};
export var Zoomin = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});